import { usePropertyCity } from '../../../../../queries/usePropertyCoreFields';
import { TextBox } from '@apply/components';
import { AddressFieldLength } from '@apply/constants';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';

interface PropertyAddressCityProps {
    propertyGuid: string;
    required?: boolean;
    readOnly?: boolean;
    isReview?: boolean;
    validator?: React.ReactNode;
}

export const PropertyAddressCity: React.FC<PropertyAddressCityProps> = ({
    propertyGuid,
    required = false,
    readOnly = false,
    isReview = false,
    validator,
}) => {
    const label = 'City';
    const [propertyAddressCity, set_propertyAddressCity] = usePropertyCity(propertyGuid);
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={propertyAddressCity}
                />
            ) : (
                <TextBox
                    id='propertyAddressCity'
                    value={propertyAddressCity}
                    onChange={(value) => set_propertyAddressCity(value)}
                    label={label}
                    placeholder='Hamilton'
                    required={required}
                    width='100%'
                    readOnly={readOnly}
                    maxLength={AddressFieldLength.city}
                    validator={validator}
                />
            )}
        </>
    );
};
